import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '@hq-core/models/app-settings';
import { DataResource } from '@hq-custom-types';
import {
    ApiCollectionResponse,
    SearchState,
} from '@cia-front-end-apps/shared/api-interaction';
import { Observable } from 'rxjs';
import { Brand } from '../models/brand';

@Injectable()
export class BrandResource implements DataResource<Brand> {
    private readonly baseUrl: string;

    constructor(
        private http: HttpClient,
        private appSettings: AppSettings,
    ) {
        this.baseUrl = `${this.appSettings.apis.vendorData}`;
    }

    getAll(searchState: SearchState): Observable<ApiCollectionResponse<Brand>> {
        const url = `${this.baseUrl}/brands`;

        const params = new HttpParams({
            fromObject: {
                pageIndex: (searchState.pageIndex ?? 0).toString(),
                pageSize: (searchState.pageSize ?? 25).toString(),
                sortBy: searchState.sortBy ?? '',
                sortDirection: searchState.sortDirection ?? 'asc',
                search: searchState.search ?? '',
            },
        });

        return this.http.get<ApiCollectionResponse<Brand>>(url, { params });
    }
}
